<template>
  <v-flex class="justify-end">
    <p class="headline" v-html="$t('tutorial.stepWelcome.TITLE')"></p>
    <p class="subheading" v-html="$t('tutorial.stepWelcome.BODY')"></p>
    <v-spacer></v-spacer>
    <v-container>
      <v-layout>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click.native="$emit('continue')">{{ $t('tutorial.buttons.CONTINUE') }}</v-btn>
      </v-layout>
    </v-container>
  </v-flex>
</template>

<script>
  export default {
    name: 'tutorial-step1'
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/tutorial/TutorialStep1.vue